import { ArticleTopperProps } from "design-system/components/toppers/article-topper/article-topper";
import { createContentfulProps } from "frontend/contentful/lib/create-contentful-props";
import { BigArtTopperEntry } from "frontend/contentful/schema/toppers";

export const createBigArtTopperProps = createContentfulProps<
  BigArtTopperEntry,
  ArticleTopperProps
>(({ entry }) => {
  const props: ArticleTopperProps = {
    isBigArt: true,
    theme: entry.fields.theme,
  };

  return props;
});
